const InstructionContent = () => {
  return (
    <div className="w-[990px] pt-[100px] pb-[100px] pl-[207px] pr-[207px] bg-white rounded-2xl flex justify-center items-center">
      <div className="text-[22px]">
        <p>Спасибо за участие в проекте «Твори добро» 🎁 </p>
        <br />
        <p>Что делать дальше: </p>
        <br />
        <p>
            ⭐️ Передай подарок в HR-отдел до 22 декабря
        </p>
        <p>
            ⭐️ Оставь записку с именем и возрастом ребенка, кому предназначается подарок (например: «для Саши А, 13 лет. От Марины К»). Это важно для организаторов — подарок обязательно должен быть подписан!
        </p>
        <p>
          ⭐️ Красиво упакуй подарок в коробку или оберточную бумагу.  Будет здорово, если ты добавишь к подарку послание для маленького получателя: с пожеланием, напутствием и приятными словами
        </p>
        <p>
            ⭐️Если ты находишься в другом городе, оформи заказ на маркетплейсе с доставкой в Нижегородский офис (Нижний Новгород, ул. Алексеевская, д. 6/16), а мы поможем с упаковкой подарка
        </p>
        <p>
            Сбор подарков в офисе до 22 декабря🎄
        </p>
        <br />
        <p>
            ❔Если будут вопросы, пиши {" "}
          {" "}
          <a href="https://t.me/arrr04ka" target="_blank">
            {" "}
            <span style={{ color: "#3F44D9" }}>Арине</span>
          </a>
          .
        </p>
      </div>
    </div>
  );
};

export default InstructionContent;
